import {Injectable} from "@angular/core";
import {PermissionMancomunadosPaymentsService} from "@monex-sistemas/nueva-banca-digital-library";

@Injectable({
    providedIn: 'root'
})
export class MenuPermissionFactoryService {

    constructor(public permissionMancomunadosService: PermissionMancomunadosPaymentsService) {
    }

    getPermissionFunction(permissionType: string) {
        switch (permissionType) {
            case 'hasFacultadesPermission':
                return (contract: any) => this.hasFacultadesPermission(contract);
            case 'showPreviousBank':
                return () => this.showPreviousBank()
            default:
                return () => false;
        }
    }

    private hasFacultadesPermission(contract: any): boolean {
        const contractId = contract.idContrato;
        return this.permissionMancomunadosService.hasFacultadesPermission(contractId)
    }

    private showPreviousBank() {
        return !!(sessionStorage.getItem('IS_REDIRECT') && sessionStorage.getItem('IS_REDIRECT') === 'true');
    }
}
